import { motion } from 'motion/react';
import { forwardRef } from 'react';

type Props = {
  className?: string;
};

const RPiece = forwardRef<HTMLDivElement, Props>(({ className }, ref) => {
  return (
    <div ref={ref} className={className}>
      <svg
        width='126'
        height='130'
        viewBox='0 0 126 130'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path d='M8.31641 129.233C3.89813 129.233 0.316406 125.652 0.316406 121.233L0.316401 8.05273C0.316401 3.63445 3.89812 0.0527342 8.3164 0.052734L117.424 0.0527293C121.843 0.0527291 125.424 3.63445 125.424 8.05273L125.424 121.233C125.424 125.652 121.843 129.233 117.424 129.233L8.31641 129.233Z' />
      </svg>
    </div>
  );
});

RPiece.displayName = 'RPiece';

export default motion.create(RPiece);
